const CUSTOMERS_UPDATED = (state, customers) => {
  state.customers = customers
}

const LOADING_UPDATED = (state, bool = true) => {
  state.loading = bool
}

export default {
  CUSTOMERS_UPDATED,
  LOADING_UPDATED
}



// WEBPACK FOOTER //
// ./src/store/modules/customers/mutations.js